/**
 * GoogleButton — "Google로 계속" (Firebase 팝업 로그인).
 *
 * firebase 인증 활성(AUTH_ENABLED) 시 노출. 클릭 → signInWithGooglePopup(동적 import).
 * 승인 도메인(Firebase authorizedDomains)만 있으면 동작 — 별도 콘솔 설정 불필요.
 * 팝업 차단/취소는 조용히 무시(사용자가 닫은 것).
 */
import { useState } from "react";
import { AUTH_ENABLED, signInWithGooglePopup } from "./session";

function GoogleG() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true" style={{ flexShrink: 0 }}>
      <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z" />
      <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18z" />
      <path fill="#FBBC05" d="M3.97 10.72a5.4 5.4 0 0 1 0-3.44V4.95H.96a9 9 0 0 0 0 8.1l3.01-2.33z" />
      <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.47.9 11.43 0 9 0A9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z" />
    </svg>
  );
}

export default function GoogleButton({ onSuccess, onError, label = "Google로 계속" }) {
  const [busy, setBusy] = useState(false);
  if (!AUTH_ENABLED) return null;

  const click = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const email = await signInWithGooglePopup();
      onSuccess?.(email);
    } catch (e) {
      const code = e?.code || "";
      // 사용자가 팝업을 닫거나 중복 요청 — 조용히.
      if (code !== "auth/popup-closed-by-user" && code !== "auth/cancelled-popup-request") {
        onError?.(e);
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={click}
      disabled={busy}
      style={{
        display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
        width: "100%", padding: "11px 12px", borderRadius: 10, border: "1px solid #dadce0",
        background: "#fff", color: "#3c4043", fontWeight: 600, fontSize: 14.5,
        cursor: busy ? "wait" : "pointer", opacity: busy ? 0.7 : 1,
      }}
    >
      <GoogleG />
      {busy ? "로그인 중…" : label}
    </button>
  );
}
